/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CreateSalesOrderInstallmentDto } from '../models/CreateSalesOrderInstallmentDto';
import type { GenerateInstallmentsDto } from '../models/GenerateInstallmentsDto';
import type { SalesOrderInstallment } from '../models/SalesOrderInstallment';
import type { UpdateSalesOrderInstallmentDto } from '../models/UpdateSalesOrderInstallmentDto';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class SalesOrderInstallmentsService {
    /**
     * Create a new installment
     * @param requestBody
     * @returns SalesOrderInstallment Installment created successfully
     * @throws ApiError
     */
    public static salesOrderInstallmentsControllerCreate(
        requestBody: CreateSalesOrderInstallmentDto,
    ): CancelablePromise<SalesOrderInstallment> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/sales-order-installments',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Invalid installment data`,
            },
        });
    }
    /**
     * Generate multiple installments automatically
     * @param requestBody
     * @returns SalesOrderInstallment Installments generated successfully
     * @throws ApiError
     */
    public static salesOrderInstallmentsControllerGenerateInstallments(
        requestBody: GenerateInstallmentsDto,
    ): CancelablePromise<Array<SalesOrderInstallment>> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/sales-order-installments/generate',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Invalid generation parameters`,
                404: `Sales order not found`,
            },
        });
    }
    /**
     * Get all installments for a sales order
     * @param orderId
     * @returns SalesOrderInstallment List of installments for the order
     * @throws ApiError
     */
    public static salesOrderInstallmentsControllerFindByOrder(
        orderId: number,
    ): CancelablePromise<Array<SalesOrderInstallment>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/sales-order-installments/by-order/{orderId}',
            path: {
                'orderId': orderId,
            },
        });
    }
    /**
     * Get all overdue installments
     * @returns SalesOrderInstallment List of overdue installments
     * @throws ApiError
     */
    public static salesOrderInstallmentsControllerFindOverdue(): CancelablePromise<Array<SalesOrderInstallment>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/sales-order-installments/overdue',
        });
    }
    /**
     * Get upcoming installments (next 30 days)
     * @returns SalesOrderInstallment List of upcoming installments
     * @throws ApiError
     */
    public static salesOrderInstallmentsControllerFindUpcoming(): CancelablePromise<Array<SalesOrderInstallment>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/sales-order-installments/upcoming',
        });
    }
    /**
     * Get installment statistics
     * @returns any Installment statistics
     * @throws ApiError
     */
    public static salesOrderInstallmentsControllerGetStatistics(): CancelablePromise<{
        totalInstallments?: number;
        pendingInstallments?: number;
        overdueInstallments?: number;
        paidInstallments?: number;
        totalPendingAmount?: number;
        totalOverdueAmount?: number;
    }> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/sales-order-installments/statistics',
        });
    }
    /**
     * Update an installment
     * @param id
     * @param requestBody
     * @returns SalesOrderInstallment Installment updated successfully
     * @throws ApiError
     */
    public static salesOrderInstallmentsControllerUpdate(
        id: number,
        requestBody: UpdateSalesOrderInstallmentDto,
    ): CancelablePromise<SalesOrderInstallment> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/sales-order-installments/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                404: `Installment not found`,
            },
        });
    }
    /**
     * Delete an installment
     * @param id
     * @returns void
     * @throws ApiError
     */
    public static salesOrderInstallmentsControllerRemove(
        id: number,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/sales-order-installments/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `Cannot delete paid installment`,
                404: `Installment not found`,
            },
        });
    }
    /**
     * Mark installment as paid
     * @param id
     * @returns SalesOrderInstallment Installment marked as paid
     * @throws ApiError
     */
    public static salesOrderInstallmentsControllerMarkAsPaid(
        id: number,
    ): CancelablePromise<SalesOrderInstallment> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/sales-order-installments/{id}/mark-paid',
            path: {
                'id': id,
            },
            errors: {
                400: `Installment already paid`,
                404: `Installment not found`,
            },
        });
    }
    /**
     * Cancel an installment
     * @param id
     * @returns void
     * @throws ApiError
     */
    public static salesOrderInstallmentsControllerCancel(
        id: number,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/sales-order-installments/{id}/cancel',
            path: {
                'id': id,
            },
            errors: {
                400: `Cannot cancel paid installment`,
                404: `Installment not found`,
            },
        });
    }
}
